/**
 * <s-gallery-scroller> — previous/next arrows for a horizontally scrolling gallery.
 *
 * Wraps a scroll container marked [data-gallery-track]. Buttons elsewhere target this
 * element with commandfor and command="--prev" / command="--next". Arrows marked
 * [data-gallery-prev] / [data-gallery-next] hide at the start and end of the track.
 */
class SGalleryScroller extends HTMLElement {
  #ac;
  #track;

  connectedCallback() {
    this.#track = this.querySelector('[data-gallery-track]');
    if (!this.#track) return;

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.addEventListener('command', (event) => {
      if (event.command === '--prev') this.#step(-1);
      if (event.command === '--next') this.#step(1);
    }, opts);

    this.#track.addEventListener('scroll', () => this.#update(), { ...opts, passive: true });
    window.addEventListener('resize', () => this.#update(), opts);
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #step(direction) {
    const rtl = getComputedStyle(this.#track).direction === 'rtl' ? -1 : 1;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollBy({ left: this.#track.clientWidth * direction * rtl, behavior: reduce ? 'auto' : 'smooth' });
  }

  #update() {
    const track = this.#track;
    const position = Math.abs(track.scrollLeft);
    const max = track.scrollWidth - track.clientWidth - 2;
    const prev = this.querySelector('[data-gallery-prev]');
    const next = this.querySelector('[data-gallery-next]');
    if (prev) prev.hidden = position <= 2;
    if (next) next.hidden = position >= max;
  }
}

customElements.define('s-gallery-scroller', SGalleryScroller);
